module.exports = __webpack_public_path__ + "static/media/UserBlue.96218c98.svg";